<div class="wrapper">
	<fa-icon icon="spinner" size="5x" animation="spin"></fa-icon>
</div>
